import script from "./buy-now.vue?vue&type=script&lang=jsx"
export * from "./buy-now.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__